export default {
  SET_REFERRALS(state, referrals) {
    state.referrals = referrals
  },
  CHANGE_REFER_STATUS(state, data) {
    const referIndex = state.referrals.findIndex((r) => r._id === data.id) 
    state.referrals[referIndex].status = data.status
    state.referrals[referIndex].statusComment = data.statusComment
  },
  SET_USERSWITHREFERRAL(state, data) {
    state.usersWithRefferals = data.usersWithRefer;
  }
}
